import {NgModule} from '@angular/core';

import {SharedModule} from '../shared/shared.module';
import {PricingRoutingModule} from './pricing-routing.module';

const MODULES = [
    SharedModule,
    PricingRoutingModule
];

import {PricingComponent} from './components/pricing/pricing.component';
import {CancelPaymentComponent} from './components/cancel-payment/cancel-payment.component';
import {SuccessfulPaymentComponent} from './components/successful-payment/successful-payment.component';

const COMPONENTS = [
    PricingComponent,
    CancelPaymentComponent,
    SuccessfulPaymentComponent
];

import {PricingService} from './services/pricing.service';
import {LazyLoadImageModule} from 'ng-lazyload-image';

const SERVICES = [
    PricingService
];

@NgModule({
    imports: [
        ...MODULES,
        LazyLoadImageModule
    ],
    providers: [
        ...SERVICES
    ],
    declarations: [
        ...COMPONENTS
    ]
})
export class PricingModule {
}
